import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsTier } from 'global-services/constants/tier/OhsTier';

class OhsQrCodeRecord {
  _id: string;

  type: ModuleType;

  reference?: string;

  moduleType?: ModuleType;

  eventType: string;

  categories: string[];

  displayMessage: string;

  confidential?: boolean;

  signature?: boolean;

  scheduledCloseDate?: boolean;

  personResponsible?: boolean;

  customFields?: boolean;

  createdBy: {
    type: ModuleType.User;
    _id: string;
    name: string;
    email: string;
  };

  tzDateCreated: string;

  dateCreated: string;

  tier?: OhsTier;

  subRows: any[];

  archived?: boolean;

  allocationOf?: { _id: string; type: ModuleType.Asset } | undefined;

  allocationActive?: boolean;

  workplaceAllocationActive?: boolean;

  enabled?: boolean;

  linkaccessToken?: string;

  qrCodeUrl?: string | null;

  constructor(tier?: OhsTier) {
    this._id = '';
    this.type = ModuleType.QrCode;
    this.tier = tier;
    this.eventType = '';
    this.categories = [];
    this.displayMessage = '';
    this.createdBy = {
      type: ModuleType.User,
      _id: '',
      name: '',
      email: '',
    };
    this.tzDateCreated = '';
    this.dateCreated = '';
    this.subRows = [];
  }
}

export default OhsQrCodeRecord;
